<template>
    <span class="policy-badge" :class="badgeClass">{{ label }}</span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { MonitoringStatus } from "@/types/Dashboard/IDashboardOverview";

const props = defineProps<{
    status: MonitoringStatus;
    label: string;
}>();

const badgeClass = computed<string>(() => {
    switch (props.status) {
        case "active":
        case "enabled":
            return "badge-active";
        case "partial":
        case "attention":
            return "badge-inactive";
        default:
            return "badge-parked";
    }
});
</script>
